import { render } from "./auctionMain.vue?vue&type=template&id=32533224&scoped=true"
import script from "./auctionMain.vue?vue&type=script&lang=js"
export * from "./auctionMain.vue?vue&type=script&lang=js"

import "./auctionMain.vue?vue&type=style&index=0&id=32533224&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32533224"]])

export default __exports__